import { render } from "./slide25.vue?vue&type=template&id=7e4e197e&scoped=true"
import script from "./slide25.vue?vue&type=script&lang=js"
export * from "./slide25.vue?vue&type=script&lang=js"

import "./slide25.vue?vue&type=style&index=0&id=7e4e197e&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4e197e"]])

export default __exports__